import { AppConfig } from '../../core/services/app-config.service';
import { Injectable } from '@angular/core';
import { CanActivate } from '@angular/router';

@Injectable({
  providedIn: 'root',
})
export class OcrEnabledGuard implements CanActivate {
  constructor(private appConfig: AppConfig) {}

  public canActivate(): boolean {
    return this.appConfig.config.ocr.enabled;
  }
}
